import i18n from '@plugins/i18n';

export default [
    {
        path: '/hello',
        redirect: '/onboarding'
    },
    {
        path: '/onboarding',
        name: 'InvestorOnboarding',
        component: () => import('@/views/InvestorOnboarding.vue'),
        meta: {
            title: i18n.t('hello')
        },
        children: [
            {
                path: 'terms',
                name: 'InvestorOnboardingTerms',
                meta: {
                    keepParentAlive: true
                },
                component: () => import('@/views/InvestorOnboardingTerms.vue')
            },
            {
                path: 'address',
                name: 'InvestorOnboardingAddress',
                meta: {
                    keepParentAlive: true
                },
                component: () => import('@/views/InvestorOnboardingAddress.vue')
            },
            {
                path: 'adviser',
                name: 'InvestorOnboardingAdviser',
                meta: {
                    keepParentAlive: true
                },
                component: () => import('@/views/InvestorOnboardingAdviser.vue')
            },
            {
                path: 'category',
                name: 'InvestorOnboardingCategory',
                meta: {
                    keepParentAlive: true
                },
                component: () => import('@/views/InvestorOnboardingCategory.vue')
            },
            {
                path: 'declaration',
                name: 'InvestorOnboardingDeclaration',
                meta: {
                    keepParentAlive: true
                },
                component: () => import('@/views/InvestorOnboardingDeclaration.vue')
            },
            {
                path: 'classification',
                name: 'InvestorOnboardingClassification',
                meta: {
                    keepParentAlive: true
                },
                component: () => import('@/views/InvestorOnboardingClassification.vue')
            }
        ]
    }
];
